export function toggleSubNav(e) {

    // Get the navigation item that is being selected/hovered over
    const $selectedItem = $(e.currentTarget);

    // If this isn't a dropdown (just a single link), then exit out
    if ($selectedItem.find('.rwnav-section__link').length > 0) { return; }

    // Prevents the mouse event from occurring if the touch event is triggered (except for the side nav trigger element)
    if (e.type === 'touchstart') { e.preventDefault(); }

    // Check to see if a menu is currently open
    const menuIsOpen = $selectedItem.hasClass('open');

    // Find the sub navgations
    let $selectedSubNav = $(`.rwnav-section-sub__group[data-list="${$selectedItem.data('list')}"]`);

    // Exit out if there is no sub navigation to display
    if ($selectedSubNav.length === 0) { return; }

    // Close all sub navigation menus to have a clean slate
    closeDropdownMenu();

    // If a menu was already open, then we know the user is trying to close it (which we've done above)
    if (menuIsOpen && e.type === 'touchstart') { return; }

    // Add the 'open' class to the selected item
    $selectedItem.addClass('open');

    // Make the selected sub nav visible
    $selectedSubNav.removeClass('hide');

    // Position the sub nav below the selected item
    $selectedSubNav.css('left', calculateDropdownPosition($selectedItem));
}

export function closeDropdownMenu() {

    // Hide all the sub nav groups
    $('.rwnav-section-sub__group').addClass('hide');

    // Remove the 'open' class from all items
    $('.rwnav-section__item').removeClass('open');
}

// Figure out where the dropdown menu should be appear (and if it should left or right aligned)
export function calculateDropdownPosition($selectedItem) {

    // Find the sub navigations
    let $selectedSubNav = $(`.rwnav-section-sub__group[data-list="${$selectedItem.data('list')}"]`);

    // Get the left side position of the selected item
    let itemLeftSide = $selectedItem.position().left;

    // There's a transparent border on the sub nav groups so that moving the mouse outside the
    // dropdown is more forgiving. This border needs to be accounted for when calculating the menu position
    const transparentBorderOffset = parseInt($selectedSubNav.css('border-left-width'), 10);

    // Get the width of the sub nav group
    const subNavWidth = parseInt($selectedSubNav.css('width'), 10);

    // Get the width of the selected item
    const itemWidth = parseInt($selectedItem.css('width'), 10);

    // Get the width of the navigation row (the page width)
    let pageWidth = parseInt($('.rwnav-section-sub').css('width'), 10);

    // Calculate where the sub nav should be positioned for right alignment
    const rightAlignPosition = (itemLeftSide + transparentBorderOffset + itemWidth) - subNavWidth;

    // Check if left-aligning the menu will make it overflow the right side of the page
    const overflowsRightSideOfPage = ((itemLeftSide + subNavWidth) > pageWidth);

    // Align the sub menu on the left unless that would make it extend past the boundaries of the right side of the page
    let menuPosition = overflowsRightSideOfPage ? rightAlignPosition : itemLeftSide - transparentBorderOffset;

    if (subNavWidth === pageWidth) { menuPosition = 0; }

    return menuPosition;
}

// Trigger the navigation menu to close (if it should)
export function triggerCloseDropdownMenu(e) {
    const $wasOn = $(e.currentTarget);
    const $movedTo = $(e.relatedTarget);

    // Check if the mouse was moved from a dropdown menu to a nav item
    const movingFromDropdownToItem = ($wasOn.hasClass('rwnav-section-sub__group') || $wasOn.hasClass('rwnav-section-sub__inner'))
                                    && ($movedTo.hasClass('rwnav-section') || $movedTo.hasClass('rwnav-section__item'));

    // Check if the mouse was moved from a nav item to a dropdown menu
    const movingFromItemToDropDown = ($wasOn.hasClass('rwnav-section__item'))
                                    && ($movedTo.hasClass('rwnav-section-sub__group') || $movedTo.hasClass('rwnav-section-sub__inner') || $movedTo.hasClass('rwnav-section-sub__link'));

    // If the mouse isn't on or moving to part of the selected
    // navigation (dropdown menu + selected nav item), then close the menu
    if (!movingFromDropdownToItem && !movingFromItemToDropDown) { closeDropdownMenu(); }
}
